import { Link } from "react-router-dom";
import EarlyAccessForm from "@/components/EarlyAccessForm";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ivory">
      {/* Big wordmark row */}
      <div className="border-t border-sage">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-16 md:py-20">
          <div className="grid md:grid-cols-12 gap-10">
            <div className="md:col-span-6">
              <p className="eyebrow eyebrow-brass mb-6">Join the House</p>
              <h3 className="font-display text-4xl md:text-5xl leading-[1.02] mb-8">
                Occasional letters. <em className="italic">Never noise.</em>
              </h3>
              <EarlyAccessForm testidPrefix="footer" />
            </div>

            <div className="md:col-span-6 grid grid-cols-2 md:grid-cols-3 gap-8 md:pl-10">
              <div>
                <p className="eyebrow eyebrow-brass mb-4">Company</p>
                <ul className="space-y-2 text-sm text-ink">
                  <li>
                    <Link to="/contact" data-testid="footer-link-contact" className="link-underline">
                      Contact us
                    </Link>
                  </li>
                  <li>
                    <Link to="/shape-the-house" data-testid="footer-link-shape" className="link-underline">
                      Shape the House
                    </Link>
                  </li>
                  <li>
                    <Link to="/story" data-testid="footer-link-story" className="link-underline">
                      Story
                    </Link>
                  </li>
                  <li>
                    <Link to="/journal" data-testid="footer-link-journal" className="link-underline">
                      Journal
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <p className="eyebrow eyebrow-brass mb-4">Find us on</p>
                <ul className="space-y-2 text-sm text-ink">
                  <li>
                    <a
                      href="https://instagram.com/byveylle"
                      target="_blank"
                      rel="noreferrer noopener"
                      data-testid="footer-link-instagram"
                      className="link-underline"
                    >
                      Instagram
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <p className="eyebrow eyebrow-brass mb-4">Legal</p>
                <ul className="space-y-2 text-sm text-ink">
                  <li>
                    <Link to="/legal/terms" data-testid="footer-link-terms" className="link-underline">
                      Terms &amp; Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to="/legal/shipping" data-testid="footer-link-shipping" className="link-underline">
                      Shipping &amp; Returns
                    </Link>
                  </li>
                  <li>
                    <Link to="/legal/privacy" data-testid="footer-link-privacy" className="link-underline">
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom row */}
      <div className="border-t border-sage">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-3">
          <p className="font-mono-stamp text-pencil" data-testid="footer-copyright">
            © 2026 Veylle, Inc.
          </p>
          <p className="font-display italic text-pencil text-lg">
            Considered in small batches. Made to be refilled.
          </p>
        </div>
      </div>
    </footer>
  );
}
